export default {
  resource: {
    zh: {
      title:"登陆日志",
      rq1: "开始日期",
      rq2: "结束日期",
      userName: "用户名",
      loginTime: "登陆时间",
      loginIp: "IP",
      loginResult: "是否成功",
      remark: "备注"
    }

  },
  hideButton: {
    "View": 1
  },
  params: {
    rq1: {
      key: "loginTime",
      tkey: "rq1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    rq2: {
      key: "loginTime",
      tkey: "rq2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    userName: {
      key: "userName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "userName", {
      key: "loginTime",
      formatter: "fdateTime"
    }, "loginIp", "loginResult", "remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "autoid",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "login/"

}
